<div class="row mt-5 mb-5">
  <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important;">
    <div class="card">
      <div class="card-body">
        <div class="market-status-table mt-2 pb-4 profile">
        <!-- Client Details Form -->
        <form #updateProfile="ngForm" *ngIf="!displayLoader">
          <ng-container *ngFor="let field of organizationFields">
            <div class="row mb-1 pl-3">
              <div class="col-lg-3 col-sm-6 label">
                <p class="label-text mb-0">{{field.label}}</p>
              </div>
              <div class="col-lg-5 col-sm-12 mb-2">
                 <input [placeholder]="field.placeholder" [ngModel]="getFieldValue(field)"
                    [type]="field.inputType || 'text'" class="form-control" [name]="field.name" disabled />
              </div>
              <app-status-icons [statusValue]="getFieldValue(field) ? 'Complete' : 'Incomplete'">
              </app-status-icons>
            </div>
          </ng-container>
        </form>

        <ng-container *ngIf="displayLoader">
          <div class="loader-container" style="width: 55%">
            <ng-container *ngFor="let i of [1,2,3,4,5,6,7]">
              <li class="t_loader">
                <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
              </li>
            </ng-container>
          </div>
        </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>